<template>
  <div class='circle' id="wrapped">
    <span
      v-for="character in alphabet"
      :key="character"
      class='item'
      :class="questionClass(character)"
    >
      <span class="d-none d-md-block">{{ character }}</span>
    </span>
  </div>
</template>

<style scoped>
.circle {
  position: relative;
  width: 21.375em;
  height: 21.375em;
  border-radius: 50%;
  padding: 0;
  list-style: none;
  left: 50%;
  transform: translateX(-50%);
}

.circle > * {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 1.25em;
  height: 1.25em;
  margin: -0.625em;
}

.circle .item {
  display: block;
  width: 2.25em;
  height: 2.25em;
  transition: all .3s ease-in-out;
  border: 2px solid #fff;
  border-radius: 50%;
  background: var(--v-accent-base);
  /*background: var(--v-secondary-base);*/
  color: #fff;
  line-height: 2.25em;
  text-align: center;
  text-decoration: none;
  cursor: default;
  opacity: .2;
}
  .circle .item.current {
    background: var(--v-accent-base);
    opacity: 1;
  }
    .answer-success .circle .item.current {
      background: var(--v-success-base);
    }
    .answer-error .circle .item.current {
      background: var(--v-error-base);
    }

  .circle .item.invalid {
    background: lightgrey;
  }

/*  This code works well for 27 characters.
 *  Different number of characters? See this:
 *  https://gist.github.com/CodingCarlos/00891fff5733ad6e3ac578bd5ae722ec
 */
.circle > *:nth-of-type(1) {
    transform: rotate(270deg) translate(10.6875em) rotate(-270deg);}
.circle > *:nth-of-type(2) {
    transform: rotate(283.333deg) translate(10.6875em) rotate(-283.333deg);}
.circle > *:nth-of-type(3) {
    transform: rotate(296.666deg) translate(10.6875em) rotate(-296.666deg);}
.circle > *:nth-of-type(4) {
    transform: rotate(309.999deg) translate(10.6875em) rotate(-309.999deg);}
.circle > *:nth-of-type(5) {
    transform: rotate(323.332deg) translate(10.6875em) rotate(-323.332deg);}
.circle > *:nth-of-type(6) {
    transform: rotate(336.665deg) translate(10.6875em) rotate(-336.665deg);}
.circle > *:nth-of-type(7) {
    transform: rotate(349.998deg) translate(10.6875em) rotate(-349.998deg);}
.circle > *:nth-of-type(8) {
    transform: rotate(363.331deg) translate(10.6875em) rotate(-363.331deg);}
.circle > *:nth-of-type(9) {
    transform: rotate(376.664deg) translate(10.6875em) rotate(-376.664deg);}
.circle > *:nth-of-type(10) {
    transform: rotate(389.997deg) translate(10.6875em) rotate(-389.997deg);}
.circle > *:nth-of-type(11) {
    transform: rotate(403.33000000000004deg) translate(10.6875em) rotate(-403.33000000000004deg);}
.circle > *:nth-of-type(12) {
    transform: rotate(416.663deg) translate(10.6875em) rotate(-416.663deg);}
.circle > *:nth-of-type(13) {
    transform: rotate(429.996deg) translate(10.6875em) rotate(-429.996deg);}
.circle > *:nth-of-type(14) {
    transform: rotate(443.329deg) translate(10.6875em) rotate(-443.329deg);}
.circle > *:nth-of-type(15) {
    transform: rotate(456.66200000000003deg) translate(10.6875em) rotate(-456.66200000000003deg);}
.circle > *:nth-of-type(16) {
    transform: rotate(469.995deg) translate(10.6875em) rotate(-469.995deg);}
.circle > *:nth-of-type(17) {
    transform: rotate(483.328deg) translate(10.6875em) rotate(-483.328deg);}
.circle > *:nth-of-type(18) {
    transform: rotate(496.661deg) translate(10.6875em) rotate(-496.661deg);}
.circle > *:nth-of-type(19) {
    transform: rotate(509.994deg) translate(10.6875em) rotate(-509.994deg);}
.circle > *:nth-of-type(20) {
    transform: rotate(523.327deg) translate(10.6875em) rotate(-523.327deg);}
.circle > *:nth-of-type(21) {
    transform: rotate(536.6600000000001deg) translate(10.6875em) rotate(-536.6600000000001deg);}
.circle > *:nth-of-type(22) {
    transform: rotate(549.9929999999999deg) translate(10.6875em) rotate(-549.9929999999999deg);}
.circle > *:nth-of-type(23) {
    transform: rotate(563.326deg) translate(10.6875em) rotate(-563.326deg);}
.circle > *:nth-of-type(24) {
    transform: rotate(576.659deg) translate(10.6875em) rotate(-576.659deg);}
.circle > *:nth-of-type(25) {
    transform: rotate(589.992deg) translate(10.6875em) rotate(-589.992deg);}
.circle > *:nth-of-type(26) {
    transform: rotate(603.325deg) translate(10.6875em) rotate(-603.325deg);}
.circle > *:nth-of-type(27) {
    transform: rotate(616.658deg) translate(10.6875em) rotate(-616.658deg);}
</style>

<script>
const CODE_A = 65;
const CODE_N = 78;
const CODE_O = 79;
const CODE_Z = 91;

function generateAbc() {
  const abc = [];
  for (let i = CODE_A; i <= CODE_N; i += 1) {
    abc.push(String.fromCharCode(i));
  }
  abc.push('Ñ');
  for (let i = CODE_O; i < CODE_Z; i += 1) {
    abc.push(String.fromCharCode(i));
  }

  return abc;
}

export default {
  name: 'GameRondo',
  data: () => ({
    alphabet: generateAbc(),
  }),
  computed: {
    questions() {
      return this.$store.state.rondo.list[this.$i18n.locale];
    },
  },
  methods: {
    questionClass(char) {
      const question = this.questions[char.toLowerCase()];
      if (!question) {
        return 'invalid';
      }

      // Is already answered?
      if (question.answered && this.isClassMode) {
        return this.colorClass(question.team - 1);
      }

      if (question.answered) {
        return question.success ? 'success' : 'error';
      }

      // Is current question?
      const { current } = this.$store.state.rondo;
      if (!current) {
        return 'remaining';
      }

      if (current.toLowerCase() === char.toLowerCase()) {
        return 'current';
      }

      return 'remaining';
    },
  },
  // watch: {
  //   answer
  // },
};
</script>
